export default "__VITE_ASSET__DfSmjnJh__"